/* Midiron: adds swipe-indicator dots to multi-image product cards site-wide */
(function () {
  function setup(sc) {
    if (sc.dataset.miDots) return;
    if (sc.hasAttribute('disabled')) return;
    var scroller = sc.querySelector('slideshow-slides');
    if (!scroller) return;
    var slides = Array.prototype.filter.call(sc.querySelectorAll('slideshow-slide'), function (s) {
      return !s.hasAttribute('hidden');
    });
    if (slides.length < 2) return;
    sc.dataset.miDots = '1';

    var wrap = document.createElement('div');
    wrap.className = 'mi-dots';
    wrap.setAttribute('aria-hidden', 'true');
    var dots = slides.map(function (_, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-active';
      wrap.appendChild(d);
      return d;
    });
    sc.appendChild(wrap);

    var ticking = false;
    function update() {
      ticking = false;
      var w = scroller.clientWidth || 1;
      var i = Math.round(Math.abs(scroller.scrollLeft) / w);
      if (i < 0) i = 0;
      if (i > dots.length - 1) i = dots.length - 1;
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
      });
    }
    scroller.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
  }

  function scan() {
    document.querySelectorAll('.card-gallery slideshow-component').forEach(setup);
  }

  function init() {
    scan();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        scan();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
